import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'

import CardRowLayoutComponent from 'app/components/CustomBlocks/layout/CardRowLayoutBlock/CardRowLayoutComponent'
import { ReactBlocks } from 'app/helpers/Blocks'

const CardRowLayoutBlock: React.FC<IWPGBlock> = (props) => {
  return (
    <ReactBlocks
      innerBlocks={props.innerBlocks}
      render={(blocks) => <CardRowLayoutComponent>{blocks}</CardRowLayoutComponent>}
    />
  )
}

export default CardRowLayoutBlock
